import * as React from 'react';
import { pure } from 'recompose';
import { RouteComponentProps } from 'react-router';
import { AssistantData, HuesgesData } from '../../model/inspectionData';
import Loading from '../../components/Loading';
import HuesgesInspection from './components/HuesgesInspection';
import { getAssistantData } from '../../shared/api/InspectionApi';
import ErrorPage, { errorType } from '../responsePage/ErrorPage';
import { isAxiosError } from '../../shared/isAxiosError';
import { postHuesgesInspectionRequest } from '../../shared/api/huesgesApi';
import SuccessPage from '../responsePage/SuccessPage';

interface State {
  loading: boolean;
  error: null | errorType;
  success: boolean;
  initalData: AssistantData | null;
}

type Props = RouteComponentProps<{ id: string; type: string }>;

class Inspection extends React.Component<Props, State> {
  state = {
    loading: true,
    error: null,
    initalData: null,
    success: false,
  };

  public componentDidMount() {
    //
    // new Promise(resolve => {
    //   resolve({
    //     vehicleManufacturer: 'BMW',
    //     vehicleModel: 'Z4',
    //     phone: 'a',
    //     mail: 'b',
    //     zipCode: 'd',
    //     initialRegistrationYear: 'v',
    //   });
    // })
    getAssistantData(this.props.match.params.id)
      .then(data => {
        let data1 = data as AssistantData;
        this.setState({ initalData: data1, loading: false, error: null });
      })
      .catch((e: Error) => {
        if (isAxiosError(e)) {
          if (e.response != null) {
            const statusCode = e.response.status;
            let error: errorType;
            switch (statusCode) {
              case 403: {
                error = 'forbidden';
                break;
              }
              case 404: {
                error = 'notfound';
                break;
              }
              default: {
                error = 'unknown';
              }
            }
            this.setState({ initalData: null, loading: false, error: error });
          }
        }
      });
  }

  render() {
    const { loading, error, initalData, success } = this.state;

    const inspectionId = this.props.match.params.id;
    const type = this.props.match.params.type;

    if (success) {
      return (
        <SuccessPage
          headerTitleLanguageEntry={'inspectionSuccessTitle'}
          successTextLanguageEntry={'inspectionSuccessText'}
        />
      );
    }

    if (loading) {
      return <Loading />;
    }

    if (error != null) {
      return (
        <ErrorPage
          error={error}
          notFound={'inspectionLoadNotFoundError'}
          forbidden={'inspectionLoadForbiddenError'}
          unknown={'inspectionLoadUnknownError'}
        />
      );
    }

    if (type === 'huesges') {
      return (
        <HuesgesInspection inspectionId={inspectionId} assistantData={initalData} onSubmitHandler={this.onSubmit} />
      );
    }

    return null;
  }

  private onSubmit = (values: HuesgesData) => {
    const inspectionId = this.props.match.params.id;
    return postHuesgesInspectionRequest(inspectionId, values).then(() => {
      this.setState({ success: true });
    });
  };
}

export default pure(Inspection);



// WEBPACK FOOTER //
// ./src/routes/inspection/Inspection.tsx